@let state = viewState();

<div class="sheet-progress" [attr.data-kind]="state.kind">
  @if (state.kind === 'progress') {
    <div
      class="workflow"
      role="list"
      [class.is-done]="state.currentIndex === steps.length - 1"
      [attr.aria-label]="dictionary.get('SalesSheetProgress') + ': ' + statusLabel()"
    >
      @for (step of steps; track step.status; let index = $index) {
        <div
          class="workflow-step"
          role="listitem"
          [attr.data-state]="stepState(index)"
          [attr.aria-label]="stageAriaLabel(index)"
          [attr.aria-current]="index === state.currentIndex ? 'step' : null"
        >
          <span class="step-marker" aria-hidden="true">
            @if (index < state.currentIndex) {
              ✓
            } @else {
              {{ index + 1 }}
            }
          </span>
          <span class="step-label">{{ stepLabel(step) }}</span>
        </div>
      }
    </div>
  } @else if (state.kind === 'invalid' || state.kind === 'failed') {
    <div class="exception-state" [attr.aria-label]="statusLabel()">
      <span
        class="exception-badge"
        [class.invalid-badge]="state.kind === 'invalid'"
        [class.failure-badge]="state.kind === 'failed'"
      >
        <span aria-hidden="true">!</span>
        {{ statusLabel() }}
      </span>
      <div class="muted-workflow" aria-hidden="true">
        @for (step of steps; track step.status; let index = $index) {
          <span class="muted-step">
            <span class="muted-marker">{{ index + 1 }}</span>
            <span class="muted-label">{{ stepLabel(step) }}</span>
          </span>
        }
      </div>
    </div>
  } @else {
    <span
      class="unknown-status"
      [attr.aria-label]="dictionary.get('SalesSheetStatusUnknown') + ': ' + statusLabel()"
    >
      {{ statusLabel() }}
    </span>
  }
</div>
